import PropTypes from "prop-types";
import { useCatalogMessage } from "./hooks/useCatalogMessage";

export function WithMessage({ children, set, number }) {
  const message = useCatalogMessage(set, number);

  if (message) {
    return children(message);
  }

  return null;
}

export default WithMessage;

WithMessage.propTypes = {
  children: PropTypes.func,
  set: PropTypes.string,
  number: PropTypes.string,
};
